import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import './Topbar.css';


export const Topbar = props => {
    const {onLogout, user} = props;
    const handleLogout = () => {
        onLogout();
    }

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-6 col-sm-8 clearfix profile-info-dropdown-container">
                    <ul className="user-info pull-left pull-none-xsm">
                        <li className="profile-info-dropdown">
                        </li>
                    </ul>
                </div>
                <div className="col-md-6 col-sm-4 clearfix">
                    <ul className="list-inline links-list pull-right" style={{ alignItems: 'center' }}>
                        <Dropdown className="nav-item dropdown">
                            <Dropdown.Toggle id="dropdown-basic" variant="light" style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', boxShadow: 'none' }}>
                                <span style={{
                                    display: 'inline-block',
                                    width: 32,
                                    height: 32,
                                    borderRadius: '50%',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    textAlign: 'center',
                                    lineHeight: '32px',
                                    fontWeight: 'bold',
                                    fontSize: '16px',
                                    marginRight: '8px',
                                    verticalAlign: 'middle',
                                }}>
                                    {user?.name ? user.name.charAt(0).toUpperCase() : ''}
                                </span>
                                <span className="d-none d-md-inline-block">{user?.name}</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="dropdown-menu-small">
                                <Dropdown.Item as="li" className="dropdown-item">
                                    <NavLink className="nav-link" to="/myprofile">
                                        <i className="material-icons">person</i>Profile
                                    </NavLink>
                                </Dropdown.Item>
                                <Dropdown.Item as="li" className="dropdown-item">
                                    <NavLink className="nav-link" to="/developer">
                                        <i className="material-icons">code</i>Developer
                                    </NavLink>
                                </Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item as="li" className="dropdown-item">
                                    <NavLink className="nav-link text-danger" to="#" onClick={e => { e.preventDefault(); handleLogout(); }}>
                                        <i className="icon-logout right"></i>Logout
                                    </NavLink>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </ul>
                </div>
            </div>
            <div>
                <ul id="system_message" className="system-messages">
                </ul>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <hr className="header-to-main"/>
                </div>
            </div>
        </Fragment>
    )}

export default Topbar;